<template>
  <main class="min-h-screen grid place-items-center p-4 text-center">
    <section aria-label="Halaman tidak ditemukan">
      <h1 class="text-5xl font-extrabold text-brand">404</h1>
      <p class="mt-2">Halaman yang Anda cari tidak ada.</p>
      <RouterLink to="/" class="mt-4 inline-block font-semibold text-brand underline">Kembali ke beranda</RouterLink>
    </section>
  </main>
</template>
